import styled from 'styled-components';

export const CofirmPopOuterWrap = styled.div(
    props => `
        width:56rem;
        display: flex;
        flex-direction: column;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l25};
    `   
);

export const ConfirmCloseIconWrap = styled.div(
    props => `
        display: flex;
        align-self: flex-end;

    `
);

export const ConfirmPopInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:${props.theme.spacing.small.s5};
    `
);

export const UserOldNameText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font15};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.base};
    `
)

export const UserNameText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-bottom: ${props.theme.spacing.large.l25};
    `
)

export const CofirmPopHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-bottom: ${props.theme.spacing.large.l20};
    `
);

export const ConfirmInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.large.l20};

        .redBoldText{
            font-weight: ${props.theme.font.fontWeight.bold};
            color: ${props.theme.colors.red.base};
        }
        .blackboldText{
            font-weight: ${props.theme.font.fontWeight.bold};
        }
    `
);

export const ConfirmPopBtnWrap  = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);

export const BackButtonWrap = styled.div(
    props => `
        display: flex;
        align-self: flex-start;
        align-items: center;
        margin-top: ${props.theme.spacing.large.l15};
    `
);

export const BackButton = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `
);

export const ConfirmCancelBtn = styled.button(
    props => `
        display: flex;
        align-self: flex-end;
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        cursor: pointer;
    `
);

